import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const d = error?.response?.data?.detail;
    if (error?.response?.status === 402 && d && d.code === "quota_exceeded") {
      toast.error(`${d.meter.replace("_", " ")} quota reached`, {
        description: d.message || `You've hit your plan limit. Add a pack or upgrade to continue.`,
        action: { label: "Billing", onClick: () => window.location.assign("/app/admin/billing") },
      });
    }
    return Promise.reject(error);
  }
);

export default api;
